import React from 'react';
import { Typography } from '@mui/material';

export default function TrustStrip({ variant = 'inline' }) {
  const isHeader = variant === 'header';

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      sx={{
        px: isHeader ? 0 : 2,
        pt: isHeader ? 0 : 1.5,
        pb: isHeader ? 0 : 0.5,
        fontSize: isHeader ? '0.75rem' : '0.8125rem',
        lineHeight: 1.35,
      }}
    >
      Ilmainen · Sitoumukseton · Monta tarjousta yhdellä hakemuksella
    </Typography>
  );
}
